import { CanvassingQANotificationFrequency } from './canvassingQaNotifications';
import { Role } from './role';

export enum InviteStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected',
}

export type UserOrgMetadataType = {
  role?: Role;
  canvassing_qa_notification_frequency?: CanvassingQANotificationFrequency;
};
